import { useRef, useState } from 'react';
// @mui
import { Box, Button, CardHeader, Stack, Table, TableContainer } from '@mui/material';
// mock
import USERLIST from '../../_mock/user';
import TableBodyComponent from './body';
import TableListHeadComponent from './header';
import PropTypes from 'prop-types';
import { useDownloadExcel } from 'react-export-table-to-excel';
import { styled } from '@mui/material/styles';
import Iconify from '../iconify';
import { useTranslation } from 'react-i18next';
import TextInput from '../Input/TextInput';

import debounce from 'lodash/debounce';
// ----------------------------------------------------------------------

TableComponent.propTypes = {
    header: PropTypes.array,
    ref: PropTypes.any,
    // order: PropTypes.oneOf(['asc', 'desc']),
    // orderBy: PropTypes.string,
    // rowCount: PropTypes.number,
    // headLabel: PropTypes.array,
    // numSelected: PropTypes.number,
    // onRequestSort: PropTypes.func,
    // onSelectAllClick: PropTypes.func,
};

const StyledTitle = styled('div')(({ theme }) => ({
    fontSize: '30px', // Cỡ chữ mặc định
    [theme.breakpoints.down('md')]: {
        fontSize: '27px', // Cỡ chữ cho màn hình trung bình
    },
    [theme.breakpoints.down('sm')]: {
        fontSize: '18px', // Cỡ chữ cho màn hình nhỏ
    },
    [theme.breakpoints.down('xs')]: {
        fontSize: '16px', // Cỡ chữ cho màn hình rất nhỏ
    },
}));
const StyledSubheader = styled('div')(({ theme }) => ({
    fontSize: '20px', // Cỡ chữ mặc định
    [theme.breakpoints.down('md')]: {
        fontSize: '25px', // Cỡ chữ cho màn hình trung bình
    },
    [theme.breakpoints.down('sm')]: {
        fontSize: '16px', // Cỡ chữ cho màn hình nhỏ
    },
    [theme.breakpoints.down('xs')]: {
        fontSize: '14px', // Cỡ chữ cho màn hình rất nhỏ
    },
}));
// ----------------------------------------------------------------------

export default function TableComponent({
    cols = [],
    dataTable = [],
    ref = null,
    title = '',
    subTitle = '',
    getData = (e) => e,
    getDataNext = (e) => e,
    lastIdDefault = 99999999999,
    total = 0,
    isFooter = true,
    fileNameDownload = '',
}) {
    const { t } = useTranslation();
    const [order, setOrder] = useState('asc');
    const tableRef = useRef(false);
    const searchValueDeboun = useRef('');
    const lastId = useRef(lastIdDefault);
    const throttled = useRef(debounce(() => getData(searchValueDeboun.current), 1000));
    const [selected, setSelected] = useState([]);

    const [orderBy, setOrderBy] = useState('name');

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelecteds = USERLIST.map((n) => n.name);
            setSelected(newSelecteds);
            return;
        }
        setSelected([]);
    };

    const table = {
        cols: cols,
        data: dataTable,
        total: 0,
        lastId: 99999999999,
        valueSearch: '',
    };

    const { onDownload } = useDownloadExcel({
        currentTableRef: tableRef.current,
        filename: t(fileNameDownload || title),
        sheet: t(fileNameDownload || title),
    });

    const searchValue = (value) => {
        if (!value) {
            value = '';
        }
        searchValueDeboun.current = value;
        // setvalueSearch(value);
        throttled.current();
    };
    return (
        <Box sx={{}}>
            {title && (
                <Stack
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'end',
                        width: '100%',
                        flexDirection: 'row',
                        position: 'sticky',
                        zIndex: 1000,
                        top: -15,
                        backgroundColor: '#fff',
                    }}
                >
                    <CardHeader
                        title={<StyledTitle>{t(title)}</StyledTitle>}
                        subheader={<StyledSubheader>{t(subTitle)}</StyledSubheader>}
                    />
                    <Stack
                        sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'top',
                            flexDirection: 'row',
                            gap: '10px',
                            marginBottom: '12px',
                        }}
                    >
                        <TextInput
                            variant="standard"
                            endAdornment
                            icon="material-symbols-light:search"
                            getValue={searchValue}
                            label={t('search')}
                        />
                        <Button variant="contained" startIcon={<Iconify icon="ei:share-apple" />} onClick={onDownload}>
                            {t('export_excel')}
                        </Button>
                    </Stack>
                </Stack>
            )}
            <TableContainer sx={{}}>
                <Table ref={tableRef} sx={{ overflow: 'hidden' }} stickyHeader={true}>
                    <TableListHeadComponent
                        order={order}
                        orderBy={orderBy}
                        headLabel={table.cols.map((col) => {
                            return { id: col.field, label: col.title, alignRight: col.position || false };
                        })}
                        rowCount={USERLIST.length}
                        numSelected={selected.length}
                        onRequestSort={handleRequestSort}
                        onSelectAllClick={handleSelectAllClick}
                    />
                    <TableBodyComponent cols={table.cols} data={table.data} />
                </Table>
            </TableContainer>
            {isFooter && (
                <Box
                    sx={{ position: 'sticky', zIndex: 1000, bottom: 0, backgroundColor: '#f1f3f4' }}
                    display={'flex'}
                    justifyContent={'space-between'}
                    alignItems={'center'}
                    paddingLeft={2}
                    // paddingRight={2}
                >
                    <Stack>
                        <span>
                            {t('total_row')}: {table.data.length}/{total}
                        </span>
                    </Stack>
                    <Button
                        variant="contained"
                        endIcon={<Iconify icon="material-symbols:skip-next-rounded" />}
                        onClick={() => getDataNext(lastId.current)}
                        disabled={table.data.length < total ? false : true}
                    >
                        {t('next')}
                    </Button>
                </Box>
            )}
        </Box>
    );
}
